var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2154 12.9899C12.6874 12.9441 13.1338 12.7522 13.493 12.4409L23.1396 4.11685C23.625 3.72524 23.9317 3.15199 23.99 2.52851C24.048 1.90496 23.8525 1.28469 23.4478 0.808864C23.0434 0.333063 22.4645 0.0427459 21.8437 0.00435447C21.2228 -0.034032 20.613 0.182745 20.1535 0.605314L12 7.64335L3.84647 0.605313C3.38698 0.183057 2.77722 -0.033716 2.15626 0.00467533C1.5356 0.0427397 0.956587 0.333061 0.552184 0.808862C0.147485 1.28466 -0.0479744 1.90528 0.0100201 2.52884C0.0683378 3.15238 0.374984 3.72526 0.860416 4.11685L10.507 12.4409C10.979 12.8496 11.5956 13.0477 12.2152 12.9903L12.2154 12.9899Z",
    fill: "#00436D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f6cb53974a70a18f79a5448f46dbe0af.svg";
export { ForwardRef as ReactComponent };